import scssVariables from '@styles/variables.module.scss';
import { useTranslation } from 'react-i18next';

import { SearchHotkeySetup } from './components/SearchHotkeySetup';
import { SearchModal } from './components/SearchModal';
import { IconButton } from '@/components/ui/IconButton';
import { uiIcons } from '@/constants/uiIcons';
import { useGetOSMetaKey } from '@/hooks/useGetOSMetaKey';
import { useSearchStore } from '@/stores/search';

export const MainSearch = () => {
  const { isMainSearchOpen, updateStore } = useSearchStore();
  const metaKey = useGetOSMetaKey();

  const toggleSearch = () =>
    updateStore({
      type: 'TOGGLE_SEARCH',
    });

  const handleClick = () => {
    return toggleSearch();
  };

  const { t } = useTranslation(['header', 'navigation']);

  return (
    <>
      <IconButton
        size="small"
        value="main-search"
        aria-controls="main-search"
        aria-expanded={isMainSearchOpen}
        selected={isMainSearchOpen}
        onClick={handleClick}
        color="secondary"
        data-automation-id="TopBarSearchButton"
        iconName={uiIcons.actions.search}
        tooltip={`${t('SearchButton')} (${metaKey} + K)`}
        iconProps={{ color: scssVariables.ColorBlack100 }}
      />

      <SearchModal />
      <SearchHotkeySetup />
    </>
  );
};
